import { UtilService } from "./../../../_global/util.service";
import {
    Component,
    OnInit,
    ViewEncapsulation,
    AfterViewInit,
} from "@angular/core";
import { GlobalService } from "../../../_global/global.service";
import { PartnerResponseModel } from "../../../_models/partner/PartnerResponseModel";
import { LoginService } from "../../../_services";
import { Router } from "@angular/router";

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    styleUrls: ["./header-nav.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit {
    public showFxCalculator;
    public bulkOrderAllowed;
    public uipermissionList = new Array<any>();
    public cdpUipermissionList = new Array<any>();

    public partnerList = new PartnerResponseModel();
    public userName: any = "";
    isTourAgent: boolean = false;
    showPGLeads: boolean = false;
    showLeads: boolean = false;
    showUserMapping: boolean = false;
    API_URL: string;

    constructor(
        public _gs: GlobalService,
        public _util: UtilService,
        public _router: Router,
        public _loginService: LoginService,
    ) {
        var cdpRole = sessionStorage.getItem("cdpRole");
        var cdpDepartment = sessionStorage.getItem("cdpDepartment");

        if (
            (cdpRole == "ADMIN" && cdpDepartment == "CARD_DEPT") ||
            cdpDepartment == "PRODUCT"
        ) {
            this.showUserMapping = true;
        }
    }

    ngOnInit() {
        console.log("this._gs.currentUser_+", this._gs.currentUser);
        if (this._gs.currentUser.partner.partnerType == "TOUR_AGENT") {
            this.isTourAgent = true;
        }
        this.API_URL = this._loginService.API_URL;
        this.userName =
            (this._gs.currentUser.firstName == null
                ? ""
                : this._gs.currentUser.firstName) +
            " " +
            (this._gs.currentUser.lastName == null
                ? ""
                : this._gs.currentUser.lastName);
        this.showFxCalculator = localStorage.getItem("showFxCalculator");
        this.bulkOrderAllowed = localStorage.getItem("bulkOrderAllowed");
        this.uipermissionList = this._gs.currentUser.uiPermissions;
        this.cdpUipermissionList = this._gs.currentUser.cpdUiPermissions;
        if (
            this.uipermissionList.includes("LEAD_CREATE_SPECIAL") &&
            this.uipermissionList.includes("LEAD_CREATE")
        ) {
            this.showPGLeads = true;
            this.showLeads = true;
        } else if (
            !this.uipermissionList.includes("LEAD_CREATE_SPECIAL") &&
            this.uipermissionList.includes("LEAD_CREATE")
        ) {
            this.showPGLeads = false;
            this.showLeads = true;
        } else if (
            this.uipermissionList.includes("LEAD_CREATE_SPECIAL") &&
            !this.uipermissionList.includes("LEAD_CREATE")
        ) {
            this.showPGLeads = true;
            this.showLeads = false;
        } else if (
            !this.uipermissionList.includes("LEAD_CREATE_SPECIAL") &&
            !this.uipermissionList.includes("LEAD_CREATE")
        ) {
            this.showPGLeads = false;
            this.showLeads = false;
        }
    }

    ngAfterViewInit() {
        mLayout.initHeader();
    }

    goToAMLDashboard() {
        this._router.navigate(["/admin/aml-dashboard"]);
    }

    goToIDFCBulkUpload() {
        this._router.navigate(["/admin/idfc-bulk-upload"]);
    }
    placeWalkinOrder(isWalkin) {
        this._router.navigate(["/quick/walkinorderplace"], {
            queryParams: { isWalkin: isWalkin },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/layouts/header-nav/header-nav.component.ts